import React from 'react'
import { Icon, Popconfirm } from 'antd'

export const tableColumns = props => [
    {
        title: 'Channel id',
        dataIndex: 'room_id',
        render: text => <span className="gx-link">{text}</span>
    },
    {
        title: 'Private / Public',
        dataIndex: 'private',
        render: is_private => (is_private === true ? <Icon type="lock" /> : <Icon type="unlock" />)
    },
    {
        title: 'Members',
        dataIndex: 'members',
        render: members => <span>{members.length}</span>
    },
    // {
    //     title: 'Distinct',
    //     dataIndex: 'distinct',
    //     render: is_distinct => (is_distinct === true ? <span>True</span> : <span>False</span>)
    // },
    {
        title: 'Created At',
        dataIndex: 'created_at',
        render: date => {
            let d = new Date(date)
            return d.toDateString()
        }
    },
    {
        title: 'Delete',
        render: (roomId, record) => {
            return (
                <Popconfirm title="Sure to delete?" onConfirm={() => props.handleDelete(record.room_id)}>
                    <a>
                        <Icon type="delete" />
                    </a>
                </Popconfirm>
            )
        }
    }
]
